<template>
  <vuestic-widget class="chart-widget" :headerText="chartTitle">
    <vuestic-chart
      v-if="chartData"
      v-bind:data="chartData"
      type="donut"
    ></vuestic-chart>
  </vuestic-widget>
</template>

<script>
export default {
  name: 'DonutChart',
  props: ['chartTitle'],
  computed: {
    chartData() {
      // const labels = Object.keys(this.orderStatus)
      // const data = Object.values(this.orderStatus)
      let palette = this.$store.getters.palette
      return {
        labels: ['North America', 'South America', 'Australia'],
        datasets: [
          {
            label: 'Population (millions)',
            backgroundColor: [
              palette.info,
              palette.primary,
              palette.success,
              palette.warning,
              palette.danger,
              '#55aa11',
              '#f40000',
              '#f47a00',
              '#ffe314'
            ],
            data: [2478, 5267, 734]
          }
        ]
      }
    }
  }
}
</script>
